// ------------------------------------
// Virtual Market
// ------------------------------------

// ------------------------------------
// Imports
// ------------------------------------
import { call, all, put, takeLatest } from 'redux-saga/effects'
import { FETCH_COMPUTED_PRODUCTS_TICKET_METRICS, FETCH_COMPUTED_PRODUCTS_METRICS, FINISH_COMPUTED_SESSION_TICKET, FETCH_COMPUTED_QUESTIONS_PRODUCTS } from '../modules/module_computed_products'
import { getTicketFailed, getTicketSucceeded, finishTicketFailed, finishTicketSucceeded, finishSessionFailed, finishSessionSucceeded } from '../modules/module_settings'
import { getProductsByMarket, getProductsByMarketSucceeded, getProductsByMarketFailed } from '../modules/module_products'
import { getMetrics, getMetricsFailed, getMetricsSucceeded } from '../modules/module_metrics'
import { getQuestions, getQuestionsSucceeded, getQuestionsFailed, asignarEstadoCuestionarios } from '../modules/module_questions'
import { fetchTicket, finishTicket, finishSession } from 'services/settings-api'
import { fetchProductsByMarket } from 'services/products-api'
import { getMetricsByMarket } from 'services/metrics-api'
import { fetchQuestions } from 'services/question-api'
import { doCallback, getProductsByDepartment } from 'utilities/general-utils'
import { API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'

import { updateSettingsStorage, updateMetricsStorage, guardarEstadoCuestionarios } from 'utilities/session-utils'
import protocols from 'common-protocols'

// ------------------------------------
// Sagas - Workers
// ------------------------------------

/*Workers*/

export function* fetchComputedProductsRequested(action) {

  const { products, ticket, metrics } = yield all({
    products: call(fetchProductsByMarket, action.token, action.idMarket, action.idPais),
    ticket: call(fetchTicket, action.token, action.idSession, action.idMarket, action.combinacion),
    metrics: call(getMetricsByMarket, action.token, action.idMarket)
  });

  let ticketActionToDo = null;

  if (ticket.response) {
    ticketActionToDo = getTicketSucceeded(ticket.response.data);
    const ticketToUpdateInStorage = ticket.response.data;
    const hasTicketToUpdateInStorage = true;

    updateSettingsStorage(ticketToUpdateInStorage, 'ticket');
    updateSettingsStorage(hasTicketToUpdateInStorage, 'hasTicket');

  } else {
    ticketActionToDo = getTicketFailed(ticket.error);
  }

  let metricsActionToDo = null;

  if (metrics.response) {
    metricsActionToDo = getMetricsSucceeded(metrics.response.data);
    const metricsToUpdateInStorage = metrics.response.data;
    updateMetricsStorage(metricsToUpdateInStorage, 'metrics');
  } else {
    metricsActionToDo = getMetricsFailed(metrics.error);
  }

  let productsActionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if (products.response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    let computedProducts = getProductsByDepartment(products.response.data, false, action.idMarket);

    productsActionToDo = getProductsByMarketSucceeded(computedProducts);
  } else {
    productsActionToDo = getProductsByMarketFailed(products.error);
  }

  //Ejecutamos acciones
  yield all([ put(productsActionToDo), put(ticketActionToDo), put(metricsActionToDo) ]);

  //Ejecutamos callback si lo hay
  if (action.callback) {
    doCallback(action.callback, message, products.response ? products.response.data : null );
  }
}

export function* fetchComputedProductsMetrictsRequested(action) {

  const { products, metrics } = yield all({
    products: call(fetchProductsByMarket, action.token, action.idMarket, action.idPais),
    metrics: call(getMetricsByMarket, action.token, action.idMarket)
  });

  let metricsActionToDo = null;

  if (metrics.response) {
    metricsActionToDo = getMetricsSucceeded(metrics.response.data);
    const metricsToUpdateInStorage = metrics.response.data;
    updateMetricsStorage(metricsToUpdateInStorage, 'metrics');
  } else {
    metricsActionToDo = getMetricsFailed(metrics.error);
  }

  let productsActionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if (products.response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    let computedProducts = getProductsByDepartment(products.response.data, false, action.idMarket);

    productsActionToDo = getProductsByMarketSucceeded(computedProducts);
  } else {
    productsActionToDo = getProductsByMarketFailed(products.error);
  }

  //Ejecutamos acciones
  yield all([ put(productsActionToDo), put(metricsActionToDo) ]);

  //Ejecutamos callback si lo hay
  if (action.callback) {
    doCallback(action.callback, message, products.response ? products.response.data : null );
  }
}

export function* finishComputedSessionTicketRequested(action) {

  const { session, ticket } = yield all({
    session: call(finishSession, action.token),
    ticket: call(finishTicket, action.token, action.ticket)
  });

  const sessionActionToDo = session.response
  ? finishSessionSucceeded(session.response.data)
  : finishSessionFailed(session.error);

  let ticketActionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if (ticket.response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    ticketActionToDo = finishTicketSucceeded(ticket.response.data);
  } else {
    ticketActionToDo = finishTicketFailed(ticket.error);
  }

  //Ejecutamos acciones
  yield all([ put(ticketActionToDo), put(sessionActionToDo) ]);

  //Ejecutamos callback si lo hay
  if (action.callback) {
    doCallback(action.callback, message, ticket.response ? ticket.response.data : null );
  }
}

export function* fetchComputedQuestionsProductsRequested(action) {
  const { questions, products } = yield all({
    questions: call(fetchQuestions, action.token),
    products: call(fetchProductsByMarket, action.token, action.idMarket, action.idPais)
  });

  let message = API_REQUEST_STATUS_FAILED;

  let questionsToDo = null;
  if (questions.response) {
    message = API_REQUEST_STATUS_SUCCEEDED;

    if (questions.response.data.length !== 0){
      questionsToDo = getQuestionsSucceeded(questions.response.data[0], questions.response.data[1], questions.response.data[2], questions.response.data[3], questions.response.data[4], questions.response.data[5]);
      const estadoCuestionarios = {
        inclusion: questions.response.data[0].activo,
        socioBasico: questions.response.data[1].activo,
        salida: questions.response.data[2].activo,
        socioCampana: questions.response.data[3].activo,
        menosSaludable: questions.response.data[4].activo,
        salidaCampaign: questions.response.data[5].activo
      }
      yield put(asignarEstadoCuestionarios(estadoCuestionarios));
      guardarEstadoCuestionarios(estadoCuestionarios);
    } else {
      questionsToDo = getQuestionsSucceeded([], [], [], [], [], []);
      const estadoCuestionarios = {
        inclusion: false,
        socioBasico: false,
        salida: false,
        socioCampana: false,
        menosSaludable: false,
        salidaCampaign: false,
      }
      yield put(asignarEstadoCuestionarios(estadoCuestionarios));
      guardarEstadoCuestionarios(estadoCuestionarios);
    }
  } else {
    questionsToDo = getQuestionsFailed(questions.error);
  }

  let productsActionToDo = null;
  if (products.response) {
    message = message === API_REQUEST_STATUS_SUCCEEDED ? API_REQUEST_STATUS_SUCCEEDED : API_REQUEST_STATUS_FAILED;
    let computedProducts = getProductsByDepartment(products.response.data, false, action.idMarket);

    productsActionToDo = getProductsByMarketSucceeded(computedProducts);
  } else {
    productsActionToDo = getProductsByMarketFailed(products.error);
  }

  //Ejecutamos acciones
  yield all([ put(questionsToDo), put(productsActionToDo) ]);

  //Ejecutamos callback si lo hay
  if (action.callback) {
    doCallback(action.callback, message, products.response ? products.response.data : null );
  }

}

// ------------------------------------
// Sagas - Watchers/Listeners
// ------------------------------------

export function* watchFetchComputedProducts () {

  yield takeLatest(FETCH_COMPUTED_PRODUCTS_TICKET_METRICS, fetchComputedProductsRequested)
}

export function* watchFetchComputedProductsAndMetrics() {

  yield takeLatest(FETCH_COMPUTED_PRODUCTS_METRICS, fetchComputedProductsMetrictsRequested)
}

export function* watchFinishComputedSesionTicket () {
  yield takeLatest(FINISH_COMPUTED_SESSION_TICKET, finishComputedSessionTicketRequested)
}

export function* watchFetchComputedQuestionsProducts() {
  yield takeLatest(FETCH_COMPUTED_QUESTIONS_PRODUCTS, fetchComputedQuestionsProductsRequested)
}

export const computedProductsSagas = [
  watchFetchComputedProducts,
  watchFetchComputedProductsAndMetrics,
  watchFinishComputedSesionTicket,
  watchFetchComputedQuestionsProducts
];



// WEBPACK FOOTER //
// ./src/store/sagas/sagas_computed_products.js